import { competitionService } from './competition';
import { apiService } from './api';

export function createBettingApi(masterEventId, activityId) {
  const command = (action, payload) => competitionService.command(masterEventId, activityId, action, payload);
  const api = {
    getSuggestedMarkets: () => apiService.getSuggestedMarkets(),
    createEvent: payload => command('createEvent', payload),
    createRound: payload => command('createRound', payload),
    createMarket: payload => command('createMarket', payload),
    creditAllUsers: amount => command('creditAllUsers', { amount }),
    setBalanceSource: source => command('setBalanceSource', { source }),
    adjustBalance: (participantId, amount) => command('adjustBalance', { participantId, amount }),
    settleMarket: (marketId, winningOption) => command('settleMarket', { marketId, winningOption }),
    concludeRound: (roundId, carryOver) => command('concludeRound', { roundId, carryOver }),
    concludeEvent: (eventId, carryOver) => command('concludeEvent', { eventId, carryOver }),
    reopenEvent: eventId => command('reopenEvent', { eventId }),
    getScoreSnapshots: async eventId => (await competitionService.load(masterEventId, activityId)).betting.snapshots.filter(s => !eventId || s.eventId === eventId),
  };
  for (const action of ['deleteEvent']) api[action] = eventId => command(action, { eventId });
  for (const action of ['deleteRound', 'openRound', 'closeRound', 'reopenRound']) api[action] = roundId => command(action, { roundId });
  for (const action of ['deleteMarket', 'closeMarket', 'reopenMarket']) api[action] = marketId => command(action, { marketId });
  return api;
}
